import React, { PropsWithChildren } from "react";

import HorizontalNavigation, {
  HorizontalNavigationTab,
} from "../../HorizontalNavigation/HorizontalNavigation";

const tabs: HorizontalNavigationTab[] = [
  {
    label: "Failed Jobs",
    path: `/Advisor/MissionControl/Jobs/Failed`,
  },
  {
    label: "Ready Jobs",
    path: `/Advisor/MissionControl/Jobs/Ready`,
  },
];

const MissionControlHorizontalNav: React.FC<PropsWithChildren<unknown>> = (
  props
) => {
  return (
    <HorizontalNavigation tabs={tabs}>{props.children}</HorizontalNavigation>
  );
};

export default MissionControlHorizontalNav;
